import type { LocationQuery } from '#vue-router'

export default defineNuxtRouteMiddleware((to, from) => {
  const [, toSlug] = to.path.split('/')
  const [, fromSlug] = from.path.split('/')
  const { isHydrating } = useNuxtApp()

  if (!isHydrating && toSlug === fromSlug) return

  const { isUnleashFeatureEnabled } = useAppConfigurationUnleashed()
  const { activeUrlParams, patchUrlParams } = useUrlParamsState('history')

  const { defaultUrlParams } = to.meta

  const patchedParams: LocationQuery = { ...to.query }

  if (defaultUrlParams) {
    for (const key of Object.keys(defaultUrlParams)) {
      if (typeof defaultUrlParams[key] === 'function') {
        const value = defaultUrlParams[key]({
          currentValue: activeUrlParams[key],
          isUnleashFeatureEnabled,
        })

        if (typeof value === 'undefined') continue

        patchedParams[key] = value
      } else {
        patchedParams[key] = defaultUrlParams[key]
      }
    }
  }

  if (!isEqual(to.query, patchedParams)) {
    patchUrlParams(patchedParams as Record<string, string | string[]>)

    return navigateTo({
      path: to.path,
      query: {
        ...to.query,
        ...patchedParams,
      },
      replace: true,
    })
  }
})
